module.exports = __webpack_public_path__ + "img/box-click.471c0b89.svg";